<template>

  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-body>
      <p><strong>Total Bhent (Rupees): {{ _.round(this.totalAmount) }}</strong></p>
      </b-card-body>
    </b-card>
    <b-card no-body>
      <b-card-body>
        <div>
          <b-tabs content-class="mt-3">
            <b-tab title="Bhent by Cash" active>

              <b-form-group label="Total Cash" label-for="totalCash">
                <b-input-group>
                  <b-form-input id="totalCash"
                                type="number"
                                v-model="totalCash"
                                placeholder="Total Cash"
                                autofocus />
                  <b-input-group-append>
                    <calculate-popover target="btnTotalCash" @ok="calculateTotalCash" />
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>

              <b-form-group label="Donation" label-for="donation">
                <b-input-group>
                  <b-form-input id="donation" type="number" v-model="donation" placeholder="Donation" />
                </b-input-group>
              </b-form-group>

              <b-form-group label="Change" label-for="change">
                <b-input-group>
                  <b-form-input id="change" type="number" v-model="change" disabled />
                </b-input-group>
              </b-form-group>

              <b-button @click="submitCash" variant="primary" :disabled="!canSubmit">
                Submit
              </b-button>

            </b-tab>
            <b-tab title="Bhent by Card">
              <p>Not implemented yet</p>
            </b-tab>
          </b-tabs>
        </div>
      </b-card-body>
    </b-card>
  </div>

</template>

<script>

  import { mapState } from 'vuex'
  import CalculatePopover from '../../reservations/CalculatePopover'
  export default {
    name: 'Payment',
    props: {
      total: Number
    },
    components: {
      CalculatePopover
    },
    watch: {
      totalCash(value) {
        let donation = isNaN(parseFloat(this.donation)) ? 0 : parseFloat(this.donation)
        let totalCash = isNaN(parseFloat(value)) ? 0 : parseFloat(value)
        let total = this.totalAmount + donation
        this.change = totalCash >= total ? totalCash - total : null
      },
      donation(value) {
        let donation = isNaN(parseFloat(value)) ? 0 : parseFloat(value)
        let totalCash = isNaN(parseFloat(this.totalCash)) ? 0 : parseFloat(this.totalCash)
        let total = this.totalAmount + donation
        this.change = totalCash >= total ? totalCash - total : null
      }
    },
    computed: {
      canSubmit() {
        let donation = isNaN(parseFloat(this.donation)) ? 0 : parseFloat(this.donation)
        let totalCash = isNaN(parseFloat(this.totalCash)) ? 0 : parseFloat(this.totalCash)
        let total = this.totalAmount + donation
        return totalCash >= total
      }
    },
    data() {
      return {
        totalCash: 0,
        donation: 0,
        change: null,
        totalAmount: 0
      }
    },
    methods: {
      calculateTotalCash(value) {
        this.totalCash = value
      },
      submitCash() {
        let donation = isNaN(parseFloat(this.donation)) ? 0 : parseFloat(this.donation);
        let totalAmount =  this.totalAmount  + donation;
        let params = {
          ticketamount: this.totalAmount,
          totalCash: this.totalCash,
          donation: this.donation,
          change: this.change,
          payment_type: 'CASH',
          totalamount: totalAmount
        }
        this.$emit('success', params);
      }
    },
    created() {
      this.totalAmount = this.total;
    }
  }

</script>

<style>

</style>
